import React, {Component} from 'react';
import classNames from 'classnames';
import Deck from 'react-slide-deck';
const { Slide } = Deck;
import { Button } from '@chartbeat/light-side/lib/components';

import TopStories from '../../containers/top-stories/top-stories';
import { changeVirtualPage } from '../../utils/virtualPaging';
import root from '../../global.cssm';

import {SLIDES} from './slides';
import styles from './app.cssm';
import slideStyles from './slides.cssm';


class App extends Component {
    constructor(props) {
        super(props);

        if (this.props.router.location.pathname.slice(0, 8) === '/stories' &&
            !this.props.router.params.currentFilter) {
            this.props.router.params.currentFilter = 'all';
        }

        this.state = {current: this.props.router.params.currentFilter ? 3 : 0};
    }

    getSlideClasses(index) {
        return classNames(
            styles[`slide${index}`],
            {[styles.slide]: index !== SLIDES.length},
            {[styles.visibleSlide]: this.state.current === index}
        );
    }

    renderTopStoriesIfNeeded() {
        if (this.state.current === SLIDES.length) {
            return this.props.children || <TopStories />;
        }
    }

    renderSlides() {
        let renderedSlides = SLIDES.map((slide, i) => {
            return (
                <Slide key={i} className={this.getSlideClasses(i)}>
                    {slide}
                    { i < 2 &&
                        <div className={slideStyles.arrowWrapper} onClick={this.changeSlide(this.state.current + 1)}>
                            <div className={slideStyles.downArrow} />
                        </div>
                    }
                    { i === 2 && <Button
                        variant="blue"
                        className={slideStyles.skipButton}
                        onClick={this.changeSlide(3)}>
                            See the Top Stories
                        </Button>
                    }
                </Slide>
            );
        });

        renderedSlides.push(
            <Slide key={SLIDES.length} className={this.getSlideClasses(SLIDES.length)} id="topStoryContainer">
                {this.renderTopStoriesIfNeeded()}
            </Slide>
        );

        return renderedSlides;
    }

    changeSlide(slideNum) {
        return () => {
            this.setState({
                current: slideNum
            })
        }
    }

    buildIndicators(style_file) {
        let indicators = [];

        for (let i = 0; i <= SLIDES.length; i++) {
            let indicatorClass = (this.state.current === i) ?
                                 style_file.indicatorActive :
                                 style_file.indicator;

            indicators.push(
                <li
                    key={i}
                    className={indicatorClass}
                    onClick={this.changeSlide(i)}>
                </li>
            );
        }

        return indicators;
    }

    renderIndicators(style_file) {
        let indicators = this.buildIndicators(style_file);
        if (this.state.current !== 3) {
            return (
                <ul className={style_file.indicatorContainer}>
                    {indicators}
                </ul>
            );
        }
    }

    onSwitchStarted = (deck) => {
        if (deck.prev === 3 &&
            this.props.router.location !== '/') {
            deck.current = deck.prev;
        }
    }

    onSwitching = (factor, deck) => {
        if (deck.state.current === 3) {
            this.props.router.push('/stories');
            changeVirtualPage('/stories', '2016 In Review - Top Stories');
        } else {
            let currentSlideNum = deck.state.current + 1;
            changeVirtualPage('/', `2016 In Review - Slide ${currentSlideNum}`);
        }

        this.setState({
            current: deck.state.current
        })
    }

    renderHeader = () => {
        return (
            <div>
                {this.state.current > 0 && <div className={root.logoLarge}/>}
                <div className={root.mobileHeader}>
                    <div className={root.logo}><div className={root.logoSmall}/></div>
                    {this.renderIndicators(root)}
                    <div
                        className={classNames(root.headerAction, root.blue)}
                        onClick={this.changeSlide(3)}>
                        Skip
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const containerClass = (this.state.showSlideshow) ?
                               styles.slideshowContainer :
                               styles.storyContainer;

        const deckClasses = {
            entering: 'deckEntering',
            current: 'deckCurrent',
            leaving: 'deckLeaving'
        }

        return (
            <div className={classNames(containerClass, styles.container)}>
                {this.renderHeader()}

                <Deck
                    current={this.state.current}
                    wheel={true}
                    factor={0.6}
                    onSwitching={this.onSwitching}
                    onSwitchStarted={this.onSwitchStarted}
                    className={styles.storyContainer}
                    slideClasses={deckClasses}
                    easing={'inQuad'}
                >
                    {this.renderSlides()}
                </Deck>
                    {this.renderIndicators(styles)}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/app/app.js